import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimeText',
})
export class DateTimeTextPipe implements PipeTransform {
  public date = [];
  constructor() {}
  public transform(value: string, arg?: any): any {
    if (value === '00:00:00' || value === null || value === '-') {
      return '-';
    }
    const timeformat = value.split(':');
    if (timeformat.length === 3) {
      return `${timeformat[1]} min ${timeformat[2]} seg`;
    }
  }
}
